module.exports = "<div class=\"col s12 col m12 col l12 no-padding\">\n    <ul class=\"breadcrumb\">\n      <li><a><em class=\"fa fa-home breadcrumb-icon\"></em></a></li> \n      <li *ngFor=\"let crumb of breadCrumbList;let last=last\" [ngClass]=\"{'breadcrumb-active':last}\">{{crumb}}</li>\n      <!-- <li class=\"back1 pull-right\" (click)=\"back1();\"></li>  -->\n    </ul>\n  \n  </div>\n  "


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1077032063/src/src/app/common/bread-crumb/bread-crumb.component.html
// module id = ../../../../../src/app/common/bread-crumb/bread-crumb.component.html
// module chunks = main